import { render, staticRenderFns } from "./prova.vue?vue&type=template&id=677ad21a&scoped=true&"
import script from "./prova.vue?vue&type=script&lang=js&"
export * from "./prova.vue?vue&type=script&lang=js&"
import style0 from "./prova.vue?vue&type=style&index=0&id=677ad21a&scoped=true&lang=css&"
import style1 from "./prova.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677ad21a",
  null
  
)

export default component.exports